module.exports = __webpack_public_path__ + "../PREHF/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../PREHF/[name].[ext]!./configs/appSettings/PREHF/appsettings.js
// module id = 758
// module chunks = 1